import { isProd } from 'utils/config';

// do not change this!
const PROD_MIXPASS_SALE_ADDRESS = '0xC8023886782064a796D53692Ba2c5E23B1402b29';

export const MIXPASS_SALE_CONFIG = isProd()
  ? {
      contractAddress: PROD_MIXPASS_SALE_ADDRESS,
    }
  : {
      contractAddress: '0x10767F40831429883b76BB8A3238ba3Da974E1e8',
    };

// TODO: keep this updated with the actual whitelist sale ids
export const Whitelist = {
  community: isProd() ? '0' : '1',
  public: isProd() ? '1' : '2',
};

export const WHITELIST_TITLE = {
  [Whitelist.community]: 'community',
  [Whitelist.public]: 'public',
};

export const mixpassToken = isProd()
  ? {
      address: '0x98C49d0Df275B3655FC1fE20C7B4a32DBEE27B24',
      tokenId: 1,
    }
  : {
      address: '0x1256ab1e949570eac18918e006ef2445dac69e52',
      tokenId: 1,
    };

export const firstWearableToken = {
  address: '0xc58d5ec9b31516321cad1d0cfd4020545843606a',
  tokenId: 1,
};
